import RegisterDevices from './RegisterDevices';

export default RegisterDevices;
